import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShield: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconShield"><Path d="M12.8696 2.24952C12.3051 2.06136 11.6949 2.06136 11.1304 2.24952L4.88037 4.33285C3.75743 4.70717 3 5.75805 3 6.94173V11.9126C3 14.6499 4.18351 16.6703 5.85876 18.2599C7.5058 19.8227 9.65956 20.9977 11.6439 22.0682C11.8662 22.1881 12.1338 22.1881 12.3561 22.0682C14.3404 20.9977 16.4942 19.8227 18.1412 18.2599C19.8165 16.6703 21 14.6499 21 11.9126V6.94173C21 5.75805 20.2426 4.70717 19.1196 4.33285L12.8696 2.24952Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShield;
